var prefix = 'dynamic-inserted-css-';
/**
 * 动态插入 CSS 样式到当前页面
 * @param id DOM 元素 ID
 * @param cssText CSS 样式内容
 */
export function insertCSS(id, cssText) {
    var style = document.getElementById(prefix + id);
    if (!style) {
        style = document.createElement('style');
        style.id = prefix + id;
        document.head.appendChild(style);
    }
    if (style.textContent !== cssText) {
        style.textContent = cssText;
    }
    return style;
}
